import { clientEnv } from '@/shared/config/env';

/** 同一 origin 下 US / oro / Rosa 共用 localStorage；key 必须带 siteId，否则会串登录态。 */
function sessionScope() {
  return clientEnv.siteId || 'default';
}

function tokenKey() {
  return `fc.player.session.${sessionScope()}`;
}

function expiresKey() {
  return `fc.player.session.expiresAt.${sessionScope()}`;
}

let memoryToken = '';
let memoryExpiresAt = '';

function persistEnabled() {
  return clientEnv.allowSessionStorage;
}

function readPersisted(key: string): string {
  if (!persistEnabled()) return '';

  const fromLocal = localStorage.getItem(key) || '';
  if (fromLocal) return fromLocal;

  const fromSession = sessionStorage.getItem(key) || '';
  if (fromSession) {
    localStorage.setItem(key, fromSession);
    sessionStorage.removeItem(key);
  }
  return fromSession;
}

function writePersisted(key: string, value: string) {
  if (!persistEnabled()) return;
  if (value) localStorage.setItem(key, value);
  else localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}

export const tokenStorage = {
  clear() {
    memoryToken = '';
    memoryExpiresAt = '';

    if (!persistEnabled()) return;
    localStorage.removeItem(tokenKey());
    localStorage.removeItem(expiresKey());
    sessionStorage.removeItem(tokenKey());
    sessionStorage.removeItem(expiresKey());
  },
  read() {
    if (memoryToken) return memoryToken;

    memoryToken = readPersisted(tokenKey());
    return memoryToken;
  },
  readExpiresAt() {
    if (memoryExpiresAt) return memoryExpiresAt;

    memoryExpiresAt = readPersisted(expiresKey());
    return memoryExpiresAt;
  },
  write(token: string, expiresAt = '') {
    memoryToken = token;
    memoryExpiresAt = expiresAt;
    writePersisted(tokenKey(), token);
    writePersisted(expiresKey(), expiresAt);
  },
};
